import { api } from "@/lib/http";
import type { FurnitureItem } from "@/types/api";

export interface UpdateReservationBody {
  checked: boolean;
  notes: string;
}

export const stagingViewApi = {
  patchItemStatus: (id: number, status: number) =>
    api.patch<FurnitureItem>(`/api/furnitureItems/${id}/status`, { status }),

  updateReservation: (roomId: number, itemId: number, body: UpdateReservationBody) =>
    api.put<void>(`/api/rooms/${roomId}/reservations/${itemId}`, body),
};
